<template>
  <div class="all-footer">
    <!-- <div class="logo-box">
      <div class="logo">
        <img src="https://cdn1.p2ipo.com/pc/home/jdzc-logo1.png" alt />
        <div class="txt" @click="toPage('aboutUsP')">关于我们</div>
        <div class="txt1" @click="toPage('aboutUsP')">About us</div>
      </div>
    </div> -->
    <footer>
      <div class="footer-box">
        <div class="footer-left">
          <div class="nav">
            <ul>
              <li>
                <span @click="toPage('streetP')">街道</span>
              </li>
              <li>
                <span @click="toPage('academyP')">院校</span>
              </li>
              <li>
                <span @click="toPage('investmentP')">投资者</span>
              </li>
              <li>
                <span @click="toPage('exchangeP')">交易所</span>
              </li>
              <li>
                <span @click="toPage('AssociationP')">协会</span>
              </li>
              <li>
                <span @click="toPage('aboutUsP')">关于我们</span>
              </li>
            </ul>
          </div>
          <p>版权所有@交大众创&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持@网银软件</p>
          <p @click="toWeb()">粤ICP备19079019号</p>
        </div>
        <div class="footer-right">
          <div class="footer-right-box">
            <div class="vx">
              <img src="https://cdn1.p2ipo.com/pc/home/weixin1.png" alt>
              <p>上市孵化器</p>
            </div>
            <div class="subscribe">
              <img src="https://cdn1.p2ipo.com/pc/home/weixin2.png" alt>
              <p>钉钉租房</p>
            </div>
          </div>
        </div>
      </div>
      <div class="where"></div>
    </footer>
  </div>
</template>
<script>
import bus from '@/common/eventBus.js';
export default {
  name: "footersP",
  methods: {
    toPage(path) {
           let sessionData = {
              data: { key: path, value: {}, navKey: 'nav' + path, pageNavList: [ { name: 'homeP', title: '首页', active: 0 } ] },
              isBlank: false
            };
      // 跳转页面公共方法
          this.cm.toPage(path, -1, sessionData);
    },
    toWeb() {
        window.location.href = 'https://beian.miit.gov.cn';
    }
  }
};
</script>
<style scoped lang="scss">
@import './FootersP.scss';
</style>




// WEBPACK FOOTER //
// src/components/pc/common/footers/FootersP.vue